/**
 * AudioContext 单例服务
 * ─────────────────────────────────────────────────────────────────────────
 * 浏览器对同时存在的 AudioContext 数量有硬性限制（Chrome ≤ 6 个）。
 * 如果每次解码波形都 new AudioContext()，打开多个音频/视频节点后会触发
 * "The number of hardware contexts provided (6) is equal to the maximum"
 * 错误，导致后续所有音频功能失效。
 *
 * 本模块提供全局唯一的 AudioContext，所有需要 decodeAudioData 的地方
 * 统一通过 getSharedAudioContext() 获取，用完无需 close()。
 *
 * 注意：decodeAudioData() 会消费（transfer）传入的 ArrayBuffer，
 * 如果需要保留原始数据请提前 slice() 一份副本。
 */

let sharedCtx = null;

/**
 * 获取全局共享的 AudioContext（懒初始化）
 * 如果之前的 context 被浏览器关闭（如页面后台回收），会自动重建。
 * @returns {AudioContext}
 */
export function getSharedAudioContext() {
  if (!sharedCtx || sharedCtx.state === 'closed') {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    sharedCtx = new Ctor();
  }
  // 部分浏览器在用户未交互时会挂起 AudioContext，这里尝试恢复
  if (sharedCtx.state === 'suspended') {
    sharedCtx.resume().catch(() => {});
  }
  return sharedCtx;
}
